import { Link } from '@tanstack/react-router'
import { SidebarMenu, SidebarMenuItem, SidebarMenuButton } from '@/components/ui/sidebar'
import { APP_HOME_PATH } from '@/lib/app-home'

export function AppLogo() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton size="lg" asChild>
          <Link to={APP_HOME_PATH} className="flex items-center gap-2 rounded-lg">
            <div className="flex aspect-square size-9 items-center justify-center rounded-md border border-sidebar-border bg-sidebar-accent">
              <img src="/favicon.svg" alt="" aria-hidden="true" className="size-6" />
            </div>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-semibold">
                Cortado <span className="text-brand">Pro</span>
              </span>
            </div>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
